import log from 'lib/log'
import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import { loadGroup } from 'state/actions/groups'

const component = universal(() => import('./BookCairBrowsePage'))

class AsyncBookCairBrowsePage extends AsyncPage {
  nonav = true

  constructor() {
    super({
      title: 'navigation./book-cair',
      pageComponent: component,
      isChromeless: true,
    })
  }

  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    try {
      const { location: { payload: { group } } } = getState()
      if (group) {
        await loadGroup({ _id: group })(dispatch, getState, opts)
      }
    } catch (err) {
      log.error(err)
    }
  }
}

export default new AsyncBookCairBrowsePage()
